import { createContext, ReactNode, useState } from 'react'

interface IScrollControlContextData {
  isScrollingContent: boolean
  setIsScrollingContent: (value: boolean) => void
}

export const ScrollControlContext = createContext<IScrollControlContextData>(
  {} as IScrollControlContextData,
)

interface IScrollControlProviderProps {
  children: ReactNode
}

export function ScrollControlProvider({
  children,
}: IScrollControlProviderProps) {
  const [isScrollingContent, setIsScrollingContent] = useState(false)

  return (
    <ScrollControlContext.Provider
      value={{ isScrollingContent, setIsScrollingContent }}
    >
      {children}
    </ScrollControlContext.Provider>
  )
}
